import { isEmpty } from "lodash/fp";
import { Id } from "storefront/lib/Id";
import { GrailedAPIHeavyListing } from "storefront/Listing/GrailedAPIHeavyListing";
import { PageType } from "storefront/Analytics/Event";
import { ModuleType } from "storefront/Analytics/EventCreators/moduleClicked";
import getProductProperties from "../getProductProperties";

export type From =
  | "article"
  | "internal"
  | "price_recommendation"
  | "matthew_williams"
  | "category"
  | "order_confirmation"
  | "favorites"
  | "marquee"
  | "followed_seller"
  | "my_feed"
  | "my_saved_searches"
  | "collection"
  | "for_you"
  | "designer"
  | "seller_shop"
  | "recently_viewed"
  | "listing"
  | "giveaway"
  | "sold"
  | "similar_listings"
  | "feed_sidebar"
  | "wishlist"
  | "closet"
  | "saved_listings"
  | "similar_listings_module"
  | "daily_picks_for_you"
  | "conversation"
  | "datazone_collection"
  | "designer_category"
  | "designer_collaboration"
  | "designer_department_category"
  | "designer_keyword"
  | "followed_designers"
  | "homepage_content"
  | "keyword"
  | "my_for_sale"
  | "my_sales"
  | "my_sizes"
  | "user_settings";

export const pageTypeFromMap: Record<PageType, From> = {
  article: "article",
  category: "category",
  closet: "closet",
  collections: "collection",
  conversation: "conversation",
  datazone_collection: "datazone_collection",
  designer_category: "designer_category",
  designer_collaboration: "designer_collaboration",
  designer_department_category: "designer_department_category",
  designer_keyword: "designer_keyword",
  designer: "designer",
  favorites: "favorites",
  followed_designers: "followed_designers",
  followed_sellers: "followed_seller",
  homepage_content: "homepage_content",
  homepage: "marquee",
  keyword: "keyword",
  listing: "listing",
  my_feed: "my_feed",
  my_for_sale: "my_for_sale",
  my_sales: "my_sales",
  my_sizes: "my_sizes",
  order_confirmation: "order_confirmation",
  saved_listings: "saved_listings",
  saved_searches: "my_saved_searches",
  search_feed: "feed_sidebar",
  seller_profile: "seller_shop",
  similar_listings_feed: "similar_listings",
  sold: "sold",
  user_settings: "user_settings",
};

export type ProductAddedToWishlistEvent = {
  object: "product";
  action: "added_to_wishlist";
  properties: {
    badges: Array<string>;
    brand: string;
    category: string;
    name: string;
    listing_id: Id;
    product_id: Id;
    size: string;
    sold: boolean;
    strata: string;
    value: number;
    from: string | null | undefined;
    pageType: PageType | null | undefined;
    hasMeasurements?: boolean;
    algoliaQueryId?: string | null;
    moduleType?: ModuleType;
    moduleName?: string;
  };
};

const productAddedToWishlist = (
  listing: GrailedAPIHeavyListing,
  from: From,
  pageType: PageType,
  moduleType?: ModuleType,
  moduleName?: string,
): ProductAddedToWishlistEvent => ({
  object: "product",
  action: "added_to_wishlist",
  properties: {
    ...getProductProperties(listing),
    from,
    pageType,
    hasMeasurements: !isEmpty(listing.measurements),
    moduleType,
    moduleName,
  },
});

export default productAddedToWishlist;
